// extracted by mini-css-extract-plugin
var _1 = "SectionTitle_container__LAf8F";
var _2 = "SectionTitle_drawerToggleButton__VHT61";
var _3 = "SectionTitle_title__QBpaP";
export { _1 as "container", _2 as "drawerToggleButton", _3 as "title" }
